export default function BespokeAccommodation() {
  return (
    <section id="accommodations" className="py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-[#C9A961]/10 rounded-full mb-4">
              <span className="text-[#C9A961] text-sm font-semibold">Bespoke Solutions</span>
            </div>
            <h2 className="text-5xl font-bold text-[#1A1F2E] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Accommodation Solutions Tailored to You
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Every traveller is different, and so are their preferences. That's why we provide a wide range of hotels, villas, apartments, and group-friendly accommodations—all matched with bespoke booking solutions tailored to your trip style, group size, and budget.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We prioritise family-friendly and Muslim-friendly travel, ensuring you can choose accommodations close to key landmarks, mosques, heritage sites, and safe neighbourhoods.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#C9A961] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-hotel-line text-white text-lg"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#1A1F2E] mb-1">Family Hotels</h4>
                  <p className="text-sm text-gray-600">Modern comfort for families</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#C9A961] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-home-smile-line text-white text-lg"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#1A1F2E] mb-1">Heritage Stays</h4>
                  <p className="text-sm text-gray-600">Traditional experiences</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#C9A961] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-white text-lg"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#1A1F2E] mb-1">Villas & Apartments</h4>
                  <p className="text-sm text-gray-600">Privacy and space</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#C9A961] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-group-line text-white text-lg"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#1A1F2E] mb-1">Group Bookings</h4>
                  <p className="text-sm text-gray-600">Perfect for large parties</p>
                </div>
              </div>
            </div>

            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="px-8 py-4 bg-[#1A1F2E] text-white rounded-lg text-base font-semibold hover:bg-[#2A3F4E] transition-all whitespace-nowrap cursor-pointer"
            >
              Find Your Perfect Stay
            </button>
          </div>

          <div className="relative">
            <div className="w-full h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/560f95d8b0b07a7147c339aa6694f2f0.jpg"
                alt="Luxury Accommodation"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-[#C9A961]/20 rounded-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
